<div style="font-size: 18px; font-weight: bold; padding: 10px">
  <span *ngIf="showclientname">{{ clientName }}</span>
  <span *ngIf="this.blotterId">: Trans ID : {{ this.blotterId }}</span>
</div>
<div id="Directions" class="instuction">
  * To Open a file click left folder name once or double click the folder
  itself.
  <br />
  * Delete, or Rename - First click on the folder you want to upload to. Then,
  once highlighted, right click the folder and select action from the menu.
  <br />
  * To Upload, click on Upload after you choose folder.
</div>
<span Id="filepath"></span>
<!-- style="display:none" -->
<span Id="filename"></span>
<span Id="datapath"></span>
<!-- <div id="filemanager"></div> -->

<div>
  <ejs-filemanager #fileManagerObj [contextMenuSettings]="contextMenuSettings" [toolbarSettings]="toolbarSettings"
    [uploadSettings]="uploadSettings" id="default-filemanager" [view]="view" [allowMultiSelection]="false"
    [allowDragAndDrop]="true" (fileDragStart)='onFileDragStart($event)' (fileDragStop)='onFileDragStop($event)'
    (fileDragging)='onFileDragging($event)' (fileDropped)='onFileDropped($event)' (beforeSend)="beforeSend($event)"
    (beforeImageLoad)="beforeImageLoad($event)" (fileOpen)="onFileOpen($event)" [ajaxSettings]="ajaxSettings"
    (uploadListCreate)="onUploadListCreate($event)" (close)="closeup()" (success)="onAjaxSuccess($event)"
    (failure)="onFailure($event)" removed="Close">
  </ejs-filemanager>
</div>
<div kendoWindowContainer></div>
<!-- Upload failed: shown large and modal so the user cannot miss it. -->
<div
  *ngIf="uploadErrorMessage"
  class="fixed inset-0 z-[20000] flex items-center justify-center bg-black/40"
  role="alertdialog"
  aria-modal="true"
  aria-labelledby="uploadFailedTitle"
>
  <div class="w-[90%] max-w-md rounded-lg border-t-8 border-red-600 bg-white p-6 text-center shadow-xl">
    <div id="uploadFailedTitle" class="mb-3 text-2xl font-bold text-red-600">Upload Failed</div>
    <p class="mb-5 text-base text-gray-800">{{ uploadErrorMessage }}</p>
    <button
      type="button"
      class="rounded-md bg-red-600 px-8 py-2 text-base font-semibold text-white hover:bg-red-700"
      (click)="dismissUploadError()"
    >
      OK
    </button>
  </div>
</div>
<!-- .zip,.jpeg,.jpg,.gif,.png,.pdf,.doc,.xls,.ppt,.rar,.mdb,.mdf,.tif,.tiff,.png,.docx-->
<div>Max file size allowed: <b>20.00 MB</b></div>
<div>File extensions allowed:</div>
<div>*.zip, *.pdf, *.doc, *.xls, *.ppt, *.rar, *.mdb, *.mdf, *.docx</div>